import gql from 'graphql-tag';
import { actionGQLFields } from '../common/action.fields.js';
import { spaceJoinRequestGQLFields, } from './spaceJoinRequest.fields.js';
export const getMemberSpaceMembershipRequestGQLQuery = (fields) => gql `
  query GetMemberSpaceMembershipRequest($status: SpaceJoinRequestStatus) {
    memberSpaceMembershipRequest(status: $status) {
      ${spaceJoinRequestGQLFields(fields)}
    }
  }
`;
export const requestSpaceMembershipGQLMutation = (fields) => gql `
  mutation RequestSpaceMemberShip($spaceId: ID!) {
    requestSpaceMembership(spaceId: $spaceId) {
      ${spaceJoinRequestGQLFields(fields)}
    }
  }
`;
export const approveSpaceMembershipRequestGQLMutation = (fields) => gql `
  mutation ApproveSpaceMembershipRequest(
    $spaceId: ID!
    $spaceMembershipRequestId: ID!
  ) {
    approveSpaceMembershipRequest(
      spaceId: $spaceId
      spaceMembershipRequestId: $spaceMembershipRequestId
    ) {
      ${actionGQLFields(fields)}
    }
  }
`;
export const declineSpaceMembershipRequestGQLMutation = (fields) => gql `
  mutation DeclineSpaceMembershipRequest(
    $spaceId: ID!
    $spaceMembershipRequestId: ID!
  ) {
    declineSpaceMembershipRequest(
      spaceId: $spaceId
      spaceMembershipRequestId: $spaceMembershipRequestId
    ) {
      ${actionGQLFields(fields)}
    }
  }
`;
export const spaceMembershipRequestsGQLQuery = (fields) => gql `
  query SpaceMembershipRequests(
    $spaceId: ID!
    $status: SpaceJoinRequestStatus
  ) {
    spaceMembershipRequests(spaceId: $spaceId, status: $status) {
      ${spaceJoinRequestGQLFields(fields)}
    }
  }
`;
